import s from "./finish.module.css";
import {finishBackground, sabinLogo} from "../../../../assets";
import {useAppContext} from "../../../../contexts";

const Finish = (props) => {
    // Destructured props
    const {currentStep} = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div
            id={"finish"}
            className={`${s.root} ${currentStep !== 6 ? s.hideContent : ""}`}
        >
            <div className={`w-full flex flex-col md:flex-row items-start justify-between gap-y-12 gap-x-12`}>
                <div className={"flex flex-row justify-center w-full md:w-max shrink-0"}>
                    <img
                        src={finishBackground}
                        alt="Background image"
                        className={"select-none"}
                    />
                </div>
                <div>
                    <img
                        src={sabinLogo}
                        alt="Sabin logo"
                        className={"w-max select-none"}
                    />
                    <h1 className={`${s.heading} ${highContrast ? "!text-[#fecc31]" : ""}`}>
                        Agradecemos por suas respostas.
                    </h1>
                    <h2 className={`${s.subHeading} ${highContrast ? "!text-white" : ""}`}>
                        Trabalhamos para melhorar ainda mais a sua experiência de compra e, também, facilitar o cuidado
                        com
                        a sua saúde!
                    </h2>
                </div>
            </div>
        </div>
    )
}

export default Finish;
